export enum ProjectionStatus {  
    BelowAverage = "Below Average", 
    Average = "Average", 
    AboveAverage = "Above Average"
}